import { updatePropertySections as updatePropertySectionsApi } from '../../../api/services/property'

export function useUpdateProperty() {
    const updatePropertySections = async (sections = []) => {
        if (!sections.length) {
            return { error: 'missing_sections' }
        }

        const response = await updatePropertySectionsApi(sections)
        
        if (!response.ok || response.error) {
            return { error: response.error || 'Unknown error' }
        }
        
        return { data: response.data }
    }

    return { updatePropertySections }
}